import { useContext } from "react";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { iconButtonStyles } from "../../../../components/Modal/ModalHeader";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import toastContext from "../../../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../../../constants/Constants";
import themeContext from "../../../../context/theme/ThemeContext";
import CopyReportIcon from "../../../../components/SVGComponents/CopyReportIcon";

const CopyReport = ()=>{

    const {disableCopyButton, setDisableCopyButton, editorRef} = useContext(studyReportContext);
     const { showToastv2 } = useContext(toastContext);
      const copyReportToClipboard =  () => {
        if (editorRef && editorRef.current) {
          editorRef.current.editor.commands.exec('copy');
          showToastv2(TOAST_TYPE.SUCCESS, "Report Copied Successfully"); 
        }
      };
      const { theme, themeName } = useContext(themeContext);
      
    return (  
        <CustomToolTipHost 
          content={"Copy"} 
          id="Copy"
          tooltipProps={{
            calloutProps: {
              styles: {
                beak: { background: "#252525;" },
                beakCurtain: { background: "#252525;" },
                calloutMain: { background: "#252525;" },
                borderRadius: "20%",
              },
            },
          }}
        >
            <div
              className="highlight-tool"
              styles={iconButtonStyles}
              onClick={() => { if(!disableCopyButton) copyReportToClipboard() }}
              style={{ cursor: `${!disableCopyButton ? 'pointer' : 'not-allowed'}`}}
              ariaLabel="Copy"
            >
              <CopyReportIcon color={theme.palette.inactiveTool }/>
            </div>
        </CustomToolTipHost> 
    );                 
}

export default CopyReport;